import { useLocation } from 'react-router-dom'

/*
 * Module to handle state passed in the react-router links and accessed through location.
 * Since that state is untyped, write here functions to generate and validate it.
 */

export const getEmcMasterIdState = (emcMasterId: string | null): { emcMasterId: string | null } => {
  return { emcMasterId }
}
export const useLocationEmcMasterId = (): string | null => {
  const { state } = useLocation()
  if (!isObjectWithKey(state, 'emcMasterId')) return null
  const emcMasterId = state['emcMasterId']

  if (typeof emcMasterId !== 'string') return null

  return emcMasterId || null
}

const isObjectWithKey = (obj: unknown, key: string): obj is { [key: string]: unknown } => {
  if (!obj) return false
  if (typeof obj !== 'object') return false

  return key in obj
}
